import { render, staticRenderFns } from "./AttributeImage.vue?vue&type=template&id=3dd40891&scoped=true&"
import script from "./AttributeImage.vue?vue&type=script&lang=js&"
export * from "./AttributeImage.vue?vue&type=script&lang=js&"
import style0 from "./AttributeImage.vue?vue&type=style&index=0&id=3dd40891&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd40891",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
installComponents(component, {VChipGroup})
